// extracted by mini-css-extract-plugin
export default {"text":"NoAccess_text__6ifSl"};